import React, { useState, useMemo } from "react";
import {
  TableRow,
  TableCell,
  IconButton,
} from "@material-ui/core";
import Chip from "@material-ui/core/Chip";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { useSelector, useDispatch } from "react-redux";
import "./ExpandedTableRow.scss";
import { dataguard_icons } from "../../../components/common/utilities";
import { RenderUserName } from "../Utility/DetailsPopupConstant";
import { openDetailsPopup } from '../Popup/ActionCreator';
import { LOCATION, BEHAVIORMODEL, ACTIVE_USERS, ROLE_NAME, ROLES, OWNERID, DATA_ASSETS, PUBLIC_DATA, POLICY, POLICYID, COUNTRY, DATASOURCE, getHierarcyDataKey, ACTIVITIES, USERS, ANOMALIES, ASSETS, OPEN_ANOMALIES } from '../Popup/ActionTypes';
import { formatNumber, renderFlag, renderCountryNamesWithPopover, ACTION_NOT_NEEDED } from "../Utility/DataguardConstant";
import { processCountryData } from "./config/pageConfigurations";
import SeverityChips from "../DataGuardCommonComponents";
import { renderDonutChart } from "./config/pageConfigurations";

const ExpandableTableRow = ({ row, columns, selectedCategory }) => {
  const [open, setOpen] = useState(false);
  const isIncognito = useSelector((state) => state.DataguardReducer.incognito);

  // Extract widths from columns configuration and prepare activeColumns for expanded table
  const firstColumnWidth = columns[0]?.width;
  const dispatch = useDispatch();
  const openPopup = (props, isChildLevel = false) => {
    dispatch(
      openDetailsPopup(props, isChildLevel)
    );
  };

  // Define which fields to show per category, with widths from pageConfigurations
  const categoryColumns = {
    locations: [
      { key: "usersCount", label: "Users", id: "usersAccumulated", width: columns.find(col => col.id === "usersAccumulated")?.width },
      { key: "anomalyCount", chartType: "pie", label: "Anomaly", id: "anomalyAccumulated", width: columns.find(col => col.id === "anomalyAccumulated")?.width },
      { key: "activitiesCount", label: "Activities", id: "activitiesAccumulated", width: columns.find(col => col.id === "activitiesAccumulated")?.width },
      { key: "dataAssetsCount", label: "Data Assets", id: "uniqueDataAssetsAccumulated", width: columns.find(col => col.id === "uniqueDataAssetsAccumulated")?.width },
    ],
    roles: [
      { key: "usersCount", label: "Users", id: "users", width: columns.find(col => col.id === "users")?.width },
      { key: "activeUsersCount", label: "Active Users", id: "activeUsersAccumulated", width: columns.find(col => col.id === "activeUsersAccumulated")?.width },
      { key: "dummy1", isdummy: true, label: "", id: "percentageOfTotalUsers", width: columns.find(col => col.id === "percentageOfTotalUsers")?.width },
      { key: "anomaliesCount", label: "Anomalies", chartType: "pie", id: "anomaliesAccumulated", width: columns.find(col => col.id === "anomaliesAccumulated")?.width },
      { key: "locations", label: "Locations",  chartType: "map", id: "locations", width: columns.find(col => col.id === "locations")?.width },
    ],
    publicdata: [
      { key: "assetsCount", label: "Public Assets", id: "assetsAccumulated", width: columns.find(col => col.id === "assetsAccumulated")?.width },
      { key: "activitiesCount", label: "Activities", id: "activitiesAccumulated", width: columns.find(col => col.id === "activitiesAccumulated")?.width },
      { key: "dummy1", isdummy: true, label: "", id: "locations", width: columns.find(col => col.id === "locations")?.width },
      { key: "dummy2", isdummy: true, label: "", id: "action", width: columns.find(col => col.id === "action")?.width },
    ],
    behaviormodels: [
      { key: "usersCount", label: "Users", id: "users", width: columns.find(col => col.id === "users")?.width },
      { key: "totalAnomaliesCount", chartType: "pie", label: "Total Anomalies", id: "totalAnomaliesByDs", width: columns.find(col => col.id === "totalAnomaliesByDs")?.width },
      { key: "severity", label: "Severity", id: "severity", width: columns.find(col => col.id === "severity")?.width },
      { key: "dummy2", isdummy: true, label: "", id: "action", width: columns.find(col => col.id === "action")?.width },
    ],

  };

  const activeColumns = categoryColumns[selectedCategory] || [];
  const getOpenCloseAnomaliesCount = (row, dsId) => {
    const anomaliesList = (selectedCategory === "roles") ? row.anomalies : row.anomaly;
    const selectedDS = anomaliesList.find((an) => an.dataSourceId === dsId);
    return {
      open: selectedDS?.Unresolved || 0,
      close: selectedDS?.totalAnomaliesCount - selectedDS?.Unresolved || 0,
    };
  };
  const getMapData = (row, dsId) => {
    console.log(row, dsId);
    return [];
  };

  // Build per data source row from accumulated values
  const perDsData = useMemo(() => {
    const dsMap = {};
    let allDsIds = new Set();

    // Collect all relevant datasource IDs for each category
    switch (selectedCategory) {
      case "behaviormodels":
        allDsIds = new Set([
          ...Object.keys(row.users || {}),
          ...Object.keys(row.totalAnomaliesByDs || {}),
          ...Object.keys(row.openAnomalies || {}),
        ]);
        break;
      case "roles":
        allDsIds = new Set([
          ...Object.keys(row.usersAccumulated || {}),
          ...Object.keys(row.anomaliesAccumulated || {}),
          ...Object.keys(row.activeUsersAccumulated || {}),
        ]);
        break;
      case "publicdata":
        allDsIds = new Set([
          ...Object.keys(row.assetsAccumulated || {}),
          ...Object.keys(row.activitiesAccumulated || {}),
        ]);
        break;
      case "locations":
        allDsIds = new Set([
          ...Object.keys(row.usersAccumulated || {}),
          ...Object.keys(row.anomalyAccumulated || {}),
          ...Object.keys(row.activitiesAccumulated || {}),
          ...Object.keys(row.uniqueDataAssetsAccumulated || {}),
        ]);
        break;
      default:
        allDsIds = new Set();
    }

    allDsIds.forEach((dsId) => {
      const dsMeta =
        row.users?.[dsId] ||
        row.totalAnomaliesByDs?.[dsId] ||
        row.openAnomalies?.[dsId] ||
        row.usersAccumulated?.[dsId] ||
        row.anomaliesAccumulated?.[dsId] ||
        row.activeUsersAccumulated?.[dsId] ||
        row.activitiesAccumulated?.[dsId] ||
        row.uniqueDataAssetsAccumulated?.[dsId] ||
        row.assetsAccumulated?.[dsId] ||
        row.publicAssetAccessCountPerDs?.[dsId] ||
        {};

      if (selectedCategory === "locations") {
        dsMap[dsId] = {
          dataSourceId: dsId,
          dataSourceName: dsMeta.dataSourceName || "-",
          dataSourceType: dsMeta.dataSourceType || "-",
          usersCount: row.usersAccumulated?.[dsId] ?? "-",
          anomalyCount: row.anomalyAccumulated?.[dsId] ?? "-",
          activitiesCount: row.activitiesAccumulated?.[dsId] ?? "-",
          dataAssetsCount: row.uniqueDataAssetsAccumulated?.[dsId] ?? "-",
          openCloseAnomaliesCount: getOpenCloseAnomaliesCount(row, dsId),
          mapData: getMapData(row, dsId),
        };
      } else if (selectedCategory === "roles") {
        dsMap[dsId] = {
          dataSourceId: dsId,
          dataSourceName: dsMeta.dataSourceName || "-",
          dataSourceType: dsMeta.dataSourceType || "-",
          usersCount: row.usersAccumulated?.[dsId] ?? "-",
          anomaliesCount: row.anomaliesAccumulated?.[dsId] ?? "-",
          activeUsersCount: row.activeUsersAccumulated?.[dsId] ?? "-",
          openCloseAnomaliesCount: getOpenCloseAnomaliesCount(row, dsId),
          countries: (row.countries || []).filter(
            (country) => country.dataSourceId === dsId
          ),
        };
      } else if (selectedCategory === "publicdata") {
        dsMap[dsId] = {
          dataSourceId: dsId,
          dataSourceName: dsMeta.dataSourceName || "-",
          dataSourceType: dsMeta.dataSourceType || "-",
          assetsCount: row.assetsAccumulated?.[dsId] ?? "-",
          activitiesCount: row.activitiesAccumulated?.[dsId] ?? "-",
        };
      } else if (selectedCategory === "behaviormodels") {
        dsMap[dsId] = {
          dataSourceId: dsId,
          dataSourceName: dsMeta.dataSourceName || "-",
          dataSourceType: dsMeta.dataSourceType || "-",
          usersCount: row.users?.[dsId]?.count ?? 0,
          totalAnomaliesCount: row.totalAnomaliesByDs?.[dsId]?.count ?? 0,
          openAnomaliesCount: row.openAnomalies?.[dsId]?.count ?? 0,
          highCount: row.totalAnomaliesByDs?.[dsId]?.high ?? 0,
          mediumCount: row.totalAnomaliesByDs?.[dsId]?.medium ?? 0,
          lowCount: row.totalAnomaliesByDs?.[dsId]?.low ?? 0,
        };
      }

    });

    return Object.values(dsMap);
  }, [row, selectedCategory]);

  const onCellClick = (e, row, col, item) => {
    const detailsPageName = selectedCategory;
    // use this for accumulated DS data in popup perDsData.map(ds => ds.dataSourceId).join(',')
    const dataSourceIds = item ? item.dataSourceId : perDsData.map(ds => ds.dataSourceId).join(',');
    // Determine if this is a child-level click (when item is provided, it's from accordion child row)
    const isChildLevel = !!item;
    // Prepare datasource details for child-level popups
    const dataSourceDetails = isChildLevel ? {
      dataSourceName: item.dataSourceName,
      dataSourceType: item.dataSourceType
    } : null;
    switch (detailsPageName.toLowerCase()) {
      case "locations":
        if (col.id === "activitiesAccumulated") {
          const props = {
            hierarchy: [LOCATION, COUNTRY, DATASOURCE, ACTIVITIES],
            subtitleDisplayName: row.location,
            [getHierarcyDataKey(COUNTRY)]: row.location,
            [getHierarcyDataKey(DATASOURCE)]: dataSourceIds,
            ...(dataSourceDetails && { dataSourceDetails })
          }
          openPopup(props, isChildLevel);
        } else if (col.id === "usersAccumulated") {
          const props = {
            hierarchy: [LOCATION, COUNTRY, DATASOURCE, USERS],
            subtitleDisplayName: row.location,
            [getHierarcyDataKey(COUNTRY)]: row.location,
            [getHierarcyDataKey(DATASOURCE)]: dataSourceIds,
            ...(dataSourceDetails && { dataSourceDetails })
          }
          openPopup(props, isChildLevel);
        } else if (col.id === "anomalyAccumulated") {
          const props = {
            hierarchy: [LOCATION, COUNTRY, DATASOURCE, ANOMALIES],
            subtitleDisplayName: row.location,
            [getHierarcyDataKey(COUNTRY)]: row.location,
            [getHierarcyDataKey(DATASOURCE)]: dataSourceIds,
            ...(dataSourceDetails && { dataSourceDetails })
          }
          openPopup(props, isChildLevel);
        } else if (col.id === "uniqueDataAssetsAccumulated") {
          const props = {
            hierarchy: [LOCATION, COUNTRY, DATASOURCE, ASSETS],
            subtitleDisplayName: row.location,
            [getHierarcyDataKey(COUNTRY)]: row.location,
            [getHierarcyDataKey(DATASOURCE)]: dataSourceIds,
            ...(dataSourceDetails && { dataSourceDetails })
          }
          openPopup(props, isChildLevel);
        }
        break;
      case "behaviormodels":
        if (col.id === "users") {
          const props = {
            hierarchy: [BEHAVIORMODEL, POLICY, DATASOURCE, USERS],
            subtitleDisplayName: row.policyName,
            [getHierarcyDataKey(POLICYID)]: row.policyId,
            [getHierarcyDataKey(DATASOURCE)]: dataSourceIds,
            ...(dataSourceDetails && { dataSourceDetails })
          }
          openPopup(props, isChildLevel);
        } else if (col.id === "totalAnomaliesByDs") {
          const props = {
            hierarchy: [BEHAVIORMODEL, POLICY, DATASOURCE, ANOMALIES],
            subtitleDisplayName: row.policyName,
            [getHierarcyDataKey(POLICYID)]: row.policyId,
            [getHierarcyDataKey(DATASOURCE)]: dataSourceIds,
            ...(dataSourceDetails && { dataSourceDetails })
          }
          openPopup(props, isChildLevel);
        } else if (col.id === "severity") {
          const props = {
            hierarchy: [BEHAVIORMODEL, POLICY, DATASOURCE, OPEN_ANOMALIES],
            subtitleDisplayName: row.policyName,
            [getHierarcyDataKey(POLICYID)]: row.policyId,
            [getHierarcyDataKey(DATASOURCE)]: dataSourceIds,
            ...(dataSourceDetails && { dataSourceDetails })
          }
          openPopup(props, isChildLevel);
        }
        break;
      case "publicdata":
        if (col.id === "assetsAccumulated") {
          const props = {
            hierarchy: [PUBLIC_DATA, ASSETS, DATASOURCE, DATA_ASSETS],
            subtitleDisplayName: RenderUserName({ value: row.ownerName }, isIncognito),
            [getHierarcyDataKey(OWNERID)]: row.ownerId,
            [getHierarcyDataKey(DATASOURCE)]: dataSourceIds,
            ...(dataSourceDetails && { dataSourceDetails })
          }
          openPopup(props, isChildLevel);
        } else if (col.id === "activitiesAccumulated") {
          const props = {
            hierarchy: [PUBLIC_DATA, ASSETS, DATASOURCE, ACTIVITIES],
            subtitleDisplayName: RenderUserName({ value: row.ownerName }, isIncognito),
            [getHierarcyDataKey(OWNERID)]: row.ownerId,
            [getHierarcyDataKey(DATASOURCE)]: dataSourceIds,
            ...(dataSourceDetails && { dataSourceDetails })
          }
          openPopup(props, isChildLevel);
        } else if (col.id === "locations") {
          const country = e?.target?.title || "";
          if (!country) return;
          const props = {
            hierarchy: [PUBLIC_DATA, ASSETS, DATASOURCE, COUNTRY],
            [getHierarcyDataKey(OWNERID)]: row.ownerId,
            subtitleDisplayName: RenderUserName({ value: row.ownerName }, isIncognito),
            [getHierarcyDataKey(DATASOURCE)]: dataSourceIds,
            [getHierarcyDataKey(COUNTRY)]: country,
            ...(dataSourceDetails && { dataSourceDetails })
          }
          openPopup(props, isChildLevel);
        }
        break;
      case "roles":
        if (col.id === "users" || col.id === "percentageOfTotalUsers") {
          const props = {
            hierarchy: [ROLES, DATASOURCE, USERS],
            subtitleDisplayName: row.roleName,
            [getHierarcyDataKey(ROLE_NAME)]: row.roleName,
            [getHierarcyDataKey(DATASOURCE)]: dataSourceIds,
            ...(dataSourceDetails && { dataSourceDetails })
          }
          openPopup(props, isChildLevel);
        } else if (col.id === "activeUsersAccumulated") {
          const props = {
            hierarchy: [ROLES, DATASOURCE, ACTIVE_USERS],
            subtitleDisplayName: row.roleName,
            [getHierarcyDataKey(ROLE_NAME)]: row.roleName,
            [getHierarcyDataKey(DATASOURCE)]: dataSourceIds,
            ...(dataSourceDetails && { dataSourceDetails })
          }
          openPopup(props, isChildLevel);
        } else if (col.id === "anomaliesAccumulated") {
          const props = {
            hierarchy: [ROLES, DATASOURCE, ANOMALIES],
            subtitleDisplayName: row.roleName,
            [getHierarcyDataKey(ROLE_NAME)]: row.roleName,
            [getHierarcyDataKey(DATASOURCE)]: dataSourceIds,
            ...(dataSourceDetails && { dataSourceDetails })
          }
          openPopup(props, isChildLevel);
        } else if (col.id === "locations") {
          const country = e?.target?.title || e?.target?.alt ||"";
          if (!country) return;
          const props = {
            hierarchy: [ROLES, DATASOURCE, COUNTRY],
            subtitleDisplayName: row.roleName,
            [getHierarcyDataKey(ROLE_NAME)]: row.roleName,
            [getHierarcyDataKey(DATASOURCE)]: dataSourceIds,
            [getHierarcyDataKey(COUNTRY)]: country,
            ...(dataSourceDetails && { dataSourceDetails })
          }
          openPopup(props, isChildLevel);
        }
        break;
      default:
        break;
    }
  };

  const handleRowClick = (e, dsId = null, mapData = null) => {
    if (perDsData.length > 1) {
      setOpen(!open);
      return;
    }
  };

    const renderLocations = (item) => {
      // Extract all locations from the countries array
      const allLocations = (item?.countries || []).flatMap((countryGroup) =>
        (countryGroup?.locations || [])
      );
      
      // Process the locations using the utility function
      const validLocations = processCountryData(allLocations);
      
      if (validLocations.length === 0) {
        return <div className="location-flag-cell">-</div>;
      }
      
      // Use the new generic function with popover support
      return renderCountryNamesWithPopover(
        validLocations,
        3, // Show 3 countries before +remaining
        "location-flag-cell"
      );
    };



  const renderPieChart = (item) => {
    if (selectedCategory === "roles" || selectedCategory === "locations") {
      const closed = item.openCloseAnomaliesCount?.close || 0;
      const open = item.openCloseAnomaliesCount?.open || 0;
      if (closed === 0 && open === 0) {
        const valueArr = [
        { count: closed,
          name: "No Anomalies",
          color: "#4CAF50"
        }];
        return renderDonutChart(valueArr, true);
      } else {
        const valueArr = [
          { count: closed,
            name: "Closed Anomalies",
            color: "#4CAF50"
          },
          {
            count: open,
            name: "Open Anomalies",
            color: "#FB0000"
          },
        ];
        return renderDonutChart(valueArr, true);
      }
    } else {
      const closed = item.totalAnomaliesCount - item.openAnomaliesCount;
      const open = item.openAnomaliesCount;
      if (closed === 0 && open === 0) {
        const valueArr = [
        { count: closed,
          name: "No Anomalies",
          color: "#4CAF50"
        }];
        return renderDonutChart(valueArr, true);
      } else {
        const valueArr = [
          { count: closed,
            name: "Closed Anomalies",
            color: "#4CAF50"
          },
          {
            count: open,
            name: "Open Anomalies",
            color: "#FB0000"
          },
        ];
        return renderDonutChart(valueArr, true);
      }
    }
  }

  const renderAnomalies = (val, extraClass, col, item) => {
    if (col.chartType === "pie") {
      return renderPieChart(item);
    } else if (col.chartType === "map") {
      return renderLocations(item);
    } else {
      return <Chip
        size="medium"
        label={val}
        color="primary"
        className={`user-chip numberValues ${extraClass}`}
      />
    }
  }

  // Helper function to render child row cells that align with parent columns
  const renderChildRowCells = (item) => {
    const cells = [];
    
    // First column: datasource name
    cells.push(
      <TableCell
        key="datasource"
        align="left"
        style={{ width: columns[0]?.width, ...columns[0]?.customStyles }}
      >
        <div className="data-guard-accordion-type first-col-sub-accord">
          <img
            className="ds-icon"
            title={item.dataSource}
            src={dataguard_icons[item.dataSourceType]}
            alt={item.dataSourceType}
          />
          <div>{item.dataSourceName}</div>
        </div>
      </TableCell>
    );

    // Map through parent columns (skipping first column) to render child data or empty cells
    for (let i = 1; i < columns.length; i++) {
      const column = columns[i];
      const activeCol = activeColumns.find(col => col.id === column.id);
      
      if (activeCol) {
        // This column has data for the child row
        if (activeCol.key === "severity" && selectedCategory === "behaviormodels") {
          cells.push(
            <TableCell
              key={column.id}
              align="center"
              style={{ width: column.width, ...column.customStyles }}
              onClick={(e) => { e.stopPropagation(); onCellClick(e, row, activeCol, item); }}
            >
              <SeverityChips
                high={item.highCount}
                medium={item.mediumCount}
                low={item.lowCount}
              />
            </TableCell>
          );
        } else {
          let extraClass = "", val = 0;
          val = typeof item[activeCol.key] === "object"
            ? formatNumber(item[activeCol.key].count)
            : formatNumber(item[activeCol.key]);
          
          if (["anomalyCount", "anomaliesCount", "totalAnomaliesCount"].includes(activeCol.key)) {
            extraClass = (val === "0" || val === 0) ? "success" : "error";
          }
          
          cells.push(
            <TableCell
              key={column.id}
              align="center"
              style={{ width: column.width, ...column.customStyles }}
              onClick={(e) => { e.stopPropagation(); onCellClick(e, row, activeCol, item); }}
            >
              {!activeCol.isdummy ? renderAnomalies(val, extraClass, activeCol, item) : "-"}
            </TableCell>
          );
        }
      } else {
        // Empty cell to maintain alignment
        cells.push(
          <TableCell
            key={column.id}
            style={{ width: column.width, ...column.customStyles }}
          >
          </TableCell>
        );
      }
    }

    // Add toggle expand cell (empty for child rows)
    if (!ACTION_NOT_NEEDED.includes(selectedCategory)) {
      cells.push(
        <TableCell key="toggle" padding="checkbox"></TableCell>
      );
    }

    return cells;
  };

  return (
    <>
      {/* Parent Row */}
      <TableRow className="clickable-table-row parent-row" onClick={handleRowClick}>
        {columns.map((column) => (
          <TableCell
            style={{
              ...column.customStyles,
              width: column.width,
            }}
            align={column.align || "center"}
            key={column.id}
          >
            <div className="content-holder" onClick={(e) => { e.stopPropagation(); onCellClick(e, row, column); }}>
              {column.renderCell
                ? column.renderCell(row[column.id], isIncognito)
                : row[column.id]}
            </div>
          </TableCell>
        ))}

        {/* Toggle Expand */}
        {!ACTION_NOT_NEEDED.includes(selectedCategory) && <TableCell padding="checkbox">
          {perDsData.length > 1 && (
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                setOpen(!open);
              }}
              style={{
                background: "#e5e9ff",
                borderRadius: 5,
                color: "#535458",
              }}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
        </TableCell>}
      </TableRow>

      {/* Child Rows - rendered directly as sibling TableRows */}
      {open && perDsData.length > 1 && perDsData.map((item, idx) => (
        <TableRow
          key={`child-${idx}`}
          className={`clickable-table-row child-row ${open ? 'child-row-visible' : ''}`}
          onClick={(e) => handleRowClick(e, item.dataSourceId, item.mapData)}
        >
          {renderChildRowCells(item)}
        </TableRow>
      ))}
    </>
  );
};

export default ExpandableTableRow;
